import { EmployeeLoansCategoryFormData } from './types';

export const GET_LOAN_SETTINGS = 'GET_LOAN_SETTINGS';
export const UPDATE_LOAN_SETTINGS = 'UPDATE_LOAN_SETTINGS';
export const LIST_LOAN_CATEGORIES = 'LIST_LOAN_CATEGORIES';
export const UPLOAD_LOAN_CATEGORY_POLICY = 'UPLOAD_LOAN_CATEGORY_POLICY';
export const CREATE_LOAN_CATEGORY = 'CREATE_LOAN_CATEGORY';
export const TOGGLE_LOAN_CATEGORY = 'TOGGLE_LOAN_CATEGORY';
export const UPDATE_LOAN_CATEGORY = 'UPDATE_LOAN_CATEGORY'; // PUT /loan-categories/{id}

export const INITIAL_FORM_DATA: EmployeeLoansCategoryFormData = {
  categoryName: '',
  policyDocumentFile: [],
  isDocumentRequired: false,
  isCategoryCritical: false,
};

export const MAX_POLICY_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const SUGGESTED_CATEGORY_NAMES: string[] = [
  'Medical & Health Emergencies',
  'Family & Personal Needs',
  'Financial Liabilities (EMI & Loans)',
  'Housing & Living Expenses',
  'Work-Related',
  'Education',
];
